import { apiRequest } from '@/utils/api-request';
import { Example } from '@/types';
import { useOrgStore } from '@/stores/org-store';

interface updateGuardrailsConfigProps {
  id: string;
  name: string;
  description: string;
  passCriteria: string;
  failCriteria: string;
  examples: Example[];
  active: boolean;
  override: boolean;
}

export const updateGuardrailsConfig = async ({
  id,
  name,
  examples,
  description,
  passCriteria,
  failCriteria,
  active,
  override,
}: updateGuardrailsConfigProps) => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest({
    url: `/guardrails/${orgId}/${id}`,
    target: 'platform',
    method: 'PATCH',
    body: {
      name,
      examples,
      guardrail_description: description,
      pass_criteria: passCriteria,
      fail_criteria: failCriteria,
      active,
      override,
    },
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to update guardrails config' };
  }

  return response;
};
